import React from "react";
import { Camera, Clock } from "lucide-react";
import { WelcomeCard } from "../../../components/WelcomeCard";

const ProfileHeader = ({
  styles,
  theme,
  language,
  isRTL,
  screenSize,
  profilePicture,
  isUploading,
  employeeData,
  fileInputRef,
  triggerFileInput,
  handleFileSelect,
  handleMouseEnter,
  handleMouseLeave,
  t,
}) => {
  return (
    <div
      style={styles.profileHeader}
     
    >
      <div style={styles.profileHeaderContent}>
        {/* Avatar */}
        <div style={styles.profileAvatarLarge}>
          {profilePicture ? (
            <img
              src={profilePicture}
              alt="Profile"
              style={{ width: "100%", height: "100%", borderRadius: "50%", objectFit: "cover" }}
            />
          ) : (
            employeeData.avatar
          )}
          <button
            style={{ ...styles.avatarEditBtn, opacity: isUploading ? 0.5 : 1 }}
            onClick={triggerFileInput}
            disabled={isUploading}
            title={isUploading ? t("uploading") : t("changePhoto")}
          >
            {isUploading
              ? <Clock size={screenSize.isMobile ? 14 : 16} />
              : <Camera size={screenSize.isMobile ? 14 : 16} />
            }
          </button>
        </div>

        <input
          ref={fileInputRef}
          type="file"
          accept="image/*"
          onChange={handleFileSelect}
          style={{ display: "none" }}
        />

        {/* Info — reuse WelcomeCard for the name */}
        <div style={styles.profileInfo}>
          <WelcomeCard
            styles={{
              welcomeCard: { background: "transparent", padding: 0, border: "none" },
              welcomeSection: { display: "block" },
              welcomeTitle: styles.profileName,
            }}
            title={employeeData.name}
            language={language}
          />
          <div style={styles.profileTitle}>{employeeData.position}</div>
          <div style={styles.profileDepartment}>{employeeData.email}</div>
        </div>
      </div>
    </div>
  );
};

export default ProfileHeader;